const ViewsFactory = require('public_framework/views_factory')

const Components = {
  RiseOfRemote: {
    Content: require('public_shared_components/content_menu_tracker')
  },
  Shared: {
    SocialShare: require('public_shared_components/social_share')
  }
}

ViewsFactory.addComponents(Components)



// WEBPACK FOOTER //
// ./front/apps/public/pages/rise_of_remote/javascripts/index.js